// extracted by mini-css-extract-plugin
export default {"legendIndicator":"Dna-z","legendNew":"Ena-z"};